'use client';

import { useTranslation } from 'react-i18next';

import { usePathname, useRouter } from 'next/navigation';

import { NavButton, NavItem, NavList, SidebarContainer } from './styles';

export const AdminSidebar = () => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const pathname = usePathname();

  const isSchoolsActive = pathname?.includes('/dashboard/schools') || false;
  const isUsersActive = pathname?.includes('/dashboard/teachers') || false;

  return (
    <SidebarContainer>
      <NavList>
        <NavItem>
          <NavButton
            $isActive={isUsersActive}
            onClick={() => router.push('/admin/dashboard/teachers')}>
            {t('admin.sideBarTeacher')}
          </NavButton>
        </NavItem>
        <NavItem>
          <NavButton
            $isActive={isSchoolsActive}
            onClick={() => router.push('/admin/dashboard/schools')}>
            {t('admin.sideBarSchool')}
          </NavButton>
        </NavItem>
      </NavList>
    </SidebarContainer>
  );
};
